export default {
    parishBaseData: 'Daten',
    parishAgeGroups: 'Altersgruppen'
}